module.exports = __webpack_public_path__ + "static/media/Bg@2x.44fe213a.jpg";